var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("Loading")
        : [
            _vm.transactions.length === 0
              ? _c("div", [_vm._v(_vm._s(_vm.noneText))])
              : _c(
                  "div",
                  { staticClass: "items-list" },
                  _vm._l(_vm.transactions, function(transaction) {
                    return _c("ListItem", {
                      key: transaction.id,
                      attrs: { transaction: transaction }
                    })
                  }),
                  1
                ),
            _vm._v(" "),
            _c("Pagination", {
              staticClass: "mt-4",
              attrs: {
                page: _vm.page,
                total: _vm.meta.total,
                "items-per-page": _vm.itemsPerPage
              },
              on: { input: _vm.loadTransactions },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }